import {
  Component,
  OnInit,
  Input,
  EventEmitter,
  Output,
  ViewChild,
} from "@angular/core";
import {} from "rxjs";
import { DocumentFacade } from "../../document-states/document.facade";
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { DocumentDialogComponent } from "./document-dialog/document-dialog.component";
import { FormGroup, FormBuilder, FormArray, Validators } from "@angular/forms";

@Component({
  selector: "cradua-upload-document",
  templateUrl: "./upload-document.component.html",
  styleUrls: ["./upload-document.component.scss"],
})
export class UploadDocumentComponent implements OnInit {
  @Input()
  completed: boolean;
  @Input()
  progress: number;
  @Input()
  error: string;
  @Input()
  isInProgress: boolean;
  @Input()
  isReady: boolean;
  @Input()
  hasFailed: boolean;
  @Output()
  emitUpload = new EventEmitter<any>();
  @Output()
  emitReset = new EventEmitter<any>();
  @Output()
  emitCancel = new EventEmitter<any>();
  @ViewChild("file", { static: false })
  file;

  public files: Set<File> = new Set();
  documentForm: FormGroup;

  constructor(
    public dialog: MatDialog,
    private fb: FormBuilder,
  ) {}

  ngOnInit() {
    this.documentForm = this.fb.group({ DocumentUploads: this.fb.array([]) });
  }

  public openUploadDialog() {
    const dialogConfig = new MatDialogConfig();

    // dialogConfig.disableClose = false;
    dialogConfig.id = "modal-component";
    dialogConfig.height = "50%";
    dialogConfig.width = "50%";
    // dialogConfig.panelClass = "custom-dialog-container";
    // dialogConfig.backdropClass = "backdropBackground";
    dialogConfig.data = {
      completed: this.completed,
      progress: this.progress,
      error: this.error,
      isInProgress: this.isInProgress,
      isReady: this.isReady,
      hasFailed: this.hasFailed,
    };

    let dialogRef = this.dialog.open(
      DocumentDialogComponent,
      dialogConfig,
    );

    dialogRef.afterClosed().subscribe((result) => {
      if (result !== undefined) {
        console.log("data ", result);
        this.emitUpload.emit(result);
        // this.dispatchFilter.emit(result);
      }
    });
  }

  get documentFormArray(): FormArray {
    return this.documentForm.get("DocumentUploads") as FormArray;
  }

  addDocument() {
    this.documentFormArray.push(
      this.fb.group({
        FileDescription: [""],
        FileTitle: ["", Validators.required],
        file: [""],
      }),
    );
  }

  onFilesAdded(event, index) {
    // const files: { [key: string]: File } = this.file.nativeElement.files;
    const [file] = event.target.files;
    console.log(
      "key ",
      this.documentForm.controls
        .DocumentUploads["controls"][index]["controls"]["file"],
    );
    this.documentForm.controls
      .DocumentUploads["controls"][index].patchValue({
        file,
      });
    console.log("key ", this.documentFormArray);
    // for (let key in files) {
    //   if (!isNaN(parseInt(key))) {
    //     this.files.add(files[key]);
    //   }
    // }
  }

  addFiles() {
    this.file.nativeElement.click();
  }

  uploadFile(value) {
    console.log(value);
    // const files: FileList = event.target.files;
    // const file = files.item(0);

    // this.documentFacade.uploadDocumentWithFile("document", file, []);

    // // clear the input form
    // event.srcElement.value = null;
    this.emitUpload.emit(value.DocumentUploads);
  }

  onResetUpload() {
    this.emitReset.emit("");
  }

  onCancelUpload() {
    this.emitCancel.emit("");
  }
}
